import React, { Component }     from "react";
import { Button, PageHeader, DropdownButton, FormControl, FormGroup, InputGroup, MenuItem, Panel, Row,Tab, Tabs, Col } from "react-bootstrap";
import { FontAwesomeIcon }      from '@fortawesome/react-fontawesome'
import BootstrapTable           from 'react-bootstrap-table-next';
import ModalCreateFolder        from "../../components/modal/ModalCreateFolder";
import ModalMoveProgramToFolder from "../../components/modal/ModalMoveProgramToFolder";
import ModalAlert               from "../../components/modal/ModalAlert";
import ModalClientExerciseDetails     from "../../components/modal/ModalClientExerciseDetails";
import uniqueId                 from 'lodash/uniqueId';
import config                   from "../../config";
import RenderLander             from "../../components/utils/RenderLander";
import BillingForm              from "../../screens/billing/BillingForm";
import { Colors }               from "../../utils/Colors";
import ModalTrainerTextMsg                 from "../../components/modal/ModalTrainerTextMsg";
import { invokeClientExerciseHistory }   from "../../utils/AwsInvoke";
import { doesTrainerHaveValidPhoneNumber } from "../../utils/CheckIfValidPhoneNumber";
import "../../css/client/TableClientExerciseHistory.css";

/*function priceFormatter(column, colIndex) {
  return (
    <h5><strong>{ column.text }</strong></h5>
  );
}
const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: "#fff"
};*/

var exercise_list_arr     = [];

//  ALL HTML tags MUST be removed for the SORT feature to work on a table  //
const columns_prog = [{
    dataField: "exercise_name",
    text: "Exercise Name",
    sort: true,
    headerStyle: () => {
        return { width: "75%", textAlign: "center", outline: 0, border: 0 };
    }
},{
    dataField: "link",
    text: "History",
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
/*},{
    dataField: "date_created",
    text: "Date",
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }*/
}];


export default class TableClientExerciseHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: true,
          search_term: "",
          showModalClientExerciseDetails: false,
          clientId: this.props.clientId
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.getExerciseHistory ();
        } catch (e) {
            alert(e);
        }
    }


    getExerciseHistory = async () => {
        var search_str  = "";
        var search_term = this.state.searchTerm;
        var client_id   = this.props.clientId;

        if(this.searchInput != undefined)
            search_str = this.searchInput.value;

        this.setState({
            searchTerm: search_str
        }, async function() {
            const resultsExerciseHistory = await invokeClientExerciseHistory(client_id, search_str.toLowerCase());

            this.setState({
                 resultsExerciseHistory: resultsExerciseHistory.data,
            }, function() {
                //this.renderExercises();
            })
        })
    }

    // Show Exercise Detail Modal
    handleViewExercise = (exercise_id, name) => {
        this.setState({
            showModalClientExerciseDetails: true,
            exerciseId:   exercise_id,
            exerciseName: name
        })
    }

    renderExercises = () => {
        var nav_arr = [];
        var exercise_history = this.state.resultsExerciseHistory;
        exercise_list_arr = []; // reset old data cached in array
        for(var key in exercise_history) {

            var name         = exercise_history[key].name;
            var exercise_id  = exercise_history[key].exercise_id;
            //var new_date     = exercise_history[key].date_created;
            //var date       = programs_data[key].date_created;
            //var new_date   = new Date(date).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});

            if(name != null) {
                    exercise_list_arr.push({
                          id: uniqueId(), // id is required for unique keys, otherwise there's an error
                          exercise_name: name,
                          link:         <span style = {{position:"relative",left:"40%", cursor: "pointer"}}
                                              onClick={this.handleViewExercise.bind(this,exercise_id, name)}>
                                              <FontAwesomeIcon key={uniqueId()} icon="heartbeat" style={{fontSize:22}}/>
                                        </span>,
                          //date_created: <span key={uniqueId()}>{ new_date}</span>
                    })
            }
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    /*setModalClientExerciseDetailsProps = (title_text, program_id) => {
        this.setState({
            modalTitleText: title_text,
            modalProgramId:  program_id,
            showModalClientExerciseDetails:  true, // true | false
        })
    }*/

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }


    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.getExerciseHistory();
    }

    clearSearchField = () => {
        // RESET URL
        //this.props.history.replace("/exercise/listAll/&")

        this.setState({
            searchTerm: "", // reset search term if resetting exerc list
            searchMsg: ""
        }, function () {
            this.getExerciseHistory(); // reload list after deleting search term
        })
    }

    renderHome() {
        var exercise_saved;

        this.renderExercises();

        return (
              <div className="programs">
                    <br/><br/>
                    <div className="clientExerciseHistoryHeaderSearchBar">
                            <span>
                                  <FormGroup>
                                     <InputGroup>
                                       <FormControl key = {uniqueId()}
                                                    type="text"
                                                    placeholder=""
                                                    defaultValue={this.state.searchTerm}
                                                    inputRef={ref => { this.searchInput = ref; }}
                                                    onKeyPress={this.handleKeyPress}
                                                />

                                         <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                               onClick={() => this.clearSearchField()}
                                         />
                                         <InputGroup.Button>
                                           <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.getExerciseHistory()}>Search</Button>
                                         </InputGroup.Button>
                                     </InputGroup>
                                   </FormGroup>
                            </span>
                    </div>
                    <BootstrapTable keyField  = "id"
                                    key       = {uniqueId()}
                                    data      = { exercise_list_arr }
                                    columns   = { columns_prog }
                                    striped hover
                                    //selectRow = { selectRow }
                                    />
              </div>
        );
    }

    render() {
        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalClientExerciseDetails = () => this.setState({ showModalClientExerciseDetails: false }); //close simple modal window

        return (
              <div className="Home">
                {this.renderHome()}

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  {this.state.showModalClientExerciseDetails ?
                      <ModalClientExerciseDetails
                          onHide         = {closeModalClientExerciseDetails}
                          clientId       = {this.state.clientId}
                          exerciseName   = {this.state.exerciseName}
                          exerciseId     = {this.state.exerciseId}
                          showModalClientExerciseDetails = {this.state.showModalClientExerciseDetails}
                          modalProgramId = {this.state.modalProgramId}
                      />
                  : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/client/TableClientExerciseHistory.js